import type { User } from './User.types';
import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';
import { useStateUpdate } from '@/shared/lib/pinia/useStateUpdate';
import { COMPANY_ID_LENGTH, CustomerType, QID_LENGTH } from '../lib/User.constants';
import { getBirthDateTimestampFromQatarId } from '../lib/User.utils';

const StoreKey = 'UserStore';

function defaultState(): User {
  return {
    userId: '',
    uuid: null,
    userIdExpiryDate: null,
    name: '',
    lastName: '',
    phone: '',
    email: '',
    dateOfBirth: null,
    customerType: CustomerType.INDIVIDUAL,
    gender: null,
    companyId: '', // TODO: deprecate it
    companyName: '', // TODO: deprecate it
    insuredName: '', // TODO: deprecate it
  };
}

export const useUserStore = defineStore(
  StoreKey,
  () => {
    const state = reactive<User>(defaultState());

    const isCompany = computed(() => state.customerType === CustomerType.COMPANY);
    const isIndividual = computed(() => state.customerType === CustomerType.INDIVIDUAL);
    const isQatarId = computed(() => state.userId.length === QID_LENGTH);
    const isCompanyId = computed(() => state.userId.length === COMPANY_ID_LENGTH);
    const userFullName = computed(() => `${state.name} ${state.lastName}`);

    const transId = computed(() => {
      if (!state.userId) return null;
      return state.userId.replace(/\D/g, '').slice(-4);
    });

    const birthYear = computed(() => {
      if (state.userId && state.userId.length === QID_LENGTH) {
        return getBirthDateTimestampFromQatarId(state.userId);
      }
      return null;
    });

    const $update = useStateUpdate<User>(state);

    return {
      state,
      $update,
      isCompany,
      isIndividual,
      userFullName,
      transId,
      isQatarId,
      isCompanyId,
      birthYear,
    };
  },
  { persist: { key: StoreKey } },
);
